var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "intl-home" }, [
    _c("section", { staticClass: "intl-home__hero" }, [
      _c("div", { staticClass: "intl-home__hero-inner" }, [
        _c("div", { staticClass: "intl-home__eyebrow" }, [
          _vm._v(_vm._s(_vm.$t("home.eyebrow"))),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "intl-home__title" }, [
          _vm._v(_vm._s(_vm.$t("home.title"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "intl-home__desc" }, [
          _vm._v(_vm._s(_vm.$t("home.desc"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "intl-home__hero-btns" }, [
          _c(
            "button",
            {
              staticClass: "intl-home__hero-btn intl-home__hero-btn--primary",
              on: {
                click: function ($event) {
                  return _vm.$router.push("/international/courses")
                },
              },
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("home.btnCourse")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "intl-home__hero-btn intl-home__hero-btn--ghost",
              on: {
                click: function ($event) {
                  return _vm.$router.push("/international/news")
                },
              },
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("home.btnNews")) + "\n        "
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "intl-home__section" }, [
      _c(
        "div",
        { staticClass: "intl-home__section-head" },
        [
          _c("div", [
            _c("h2", { staticClass: "intl-home__section-title" }, [
              _vm._v(_vm._s(_vm.$t("home.newsTitle"))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "intl-home__section-sub" }, [
              _vm._v(_vm._s(_vm.$t("home.newsSub"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "intl-home__more",
              attrs: { to: "/international/news" },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("common.more")) + "\n      ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.featureNews || _vm.newsList.length
        ? _c("div", { staticClass: "intl-home__news-grid" }, [
            _vm.featureNews
              ? _c(
                  "div",
                  {
                    staticClass: "intl-home__feature",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          path: "/international/newsDetail",
                          query: { id: _vm.featureNews.id },
                        })
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "intl-home__feature-tag" }, [
                      _vm._v(_vm._s(_vm.$t("home.featureTag"))),
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "intl-home__feature-title" }, [
                      _vm._v(_vm._s(_vm.featureTitle)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "intl-home__feature-desc" }, [
                      _vm._v(_vm._s(_vm.featureDesc)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "intl-home__feature-meta" }, [
                      _c("span", [_vm._v(_vm._s(_vm.featureNews.date))]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "intl-home__news-list" },
              _vm._l(_vm.newsList, function (item) {
                return _c("NewsCard", {
                  key: item.id,
                  attrs: { news: item },
                  on: { click: _vm.goNewsDetail },
                })
              }),
              1
            ),
          ])
        : _c("div", { staticClass: "intl-home__loading" }, [
            _vm._v(_vm._s(_vm.loadingText)),
          ]),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "intl-home__section" },
      [
        _c(
          "div",
          { staticClass: "intl-home__section-head" },
          [
            _c("div", [
              _c("h2", { staticClass: "intl-home__section-title" }, [
                _vm._v(_vm._s(_vm.$t("home.courseTitle"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "intl-home__section-sub" }, [
                _vm._v(_vm._s(_vm.$t("home.courseSub"))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "intl-home__more",
                attrs: { to: "/international/courses" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("home.courseMore")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.courseCats.length
          ? _c("CategoryFilter", {
              attrs: { categories: _vm.courseCats, active: _vm.activeCat },
              on: { change: _vm.onCatChange },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.courseList.length
          ? _c(
              "div",
              { staticClass: "intl-home__course-grid" },
              _vm._l(_vm.courseList, function (course) {
                return _c("CourseCard", {
                  key: course.id,
                  attrs: { course: course },
                  on: { click: _vm.goCourseDetail },
                })
              }),
              1
            )
          : _c("div", { staticClass: "intl-home__loading" }, [
              _vm._v(_vm._s(_vm.loadingText)),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }